// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"5946ea44","731":"caf0895a","844":"fcbbbb4c","985":"da11df23"}[chunkId] + ".chunk.js";
};